import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MainComponent } from "./main/main.component";
import { BaseModule } from "./base/base.module";
import { NewsComponent } from "./main/news/news.component";
import { OrganizationsComponent } from "./main/organizations/organizations.component";
import { CompetitionsComponent } from "./main/competitions/competitions.component";
import { MainCouncilComponent } from "./council/main-council/main-council.component";
import { NationalityCouncilComponent } from "./council/nationality-council/nationality-council.component";
import { SightsComponent } from "./sights/sights.component";
import { ContactsComponent } from "./contacts/contacts.component";
import { ElectionComponent } from "./election/election.component";
import { CommonDatasComponent } from "./common-datas/common-datas.component";
import { DocumentsComponent } from "./council/main-council/documents/documents.component";
import { MainTasksComponent } from "./council/main-council/main-tasks/main-tasks.component";
import { OfficersComponent } from "./council/main-council/officers/officers.component";
import { SecondedComponent } from "./council/main-council/seconded/seconded.component";
import { CouncilInformationsComponent } from "./council/main-council/council-information/council-information.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { NoDataComponent } from "./no-data/no-data.component";
import { HvbComponent } from "./hvb/hvb.component";
import { DownloadService } from "./base/services/download.service";
import { PrivacyComponent } from "./privacy/privacy.component";
import { FileLoaderService } from "./services/file-loader.service";
import { HttpClientModule } from "@angular/common/http";
import { AdministrationComponent } from "./main/administration/administration.component";
import { CommunityComponent } from "./main/community/community.component";
import { ElectionDetailsComponent } from "./election-details/election-details.component";
import { Election2024Component } from "./election-2024/election-2024.component";

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    NewsComponent,
    OrganizationsComponent,
    CompetitionsComponent,
    MainCouncilComponent,
    NationalityCouncilComponent,
    SightsComponent,
    ContactsComponent,
    ElectionComponent,
    AdministrationComponent,
    CommonDatasComponent,
    DocumentsComponent,
    Election2024Component,
    ElectionDetailsComponent,
    MainTasksComponent,
    OfficersComponent,
    SecondedComponent,
    CouncilInformationsComponent,
    NoDataComponent,
    HvbComponent,
    PrivacyComponent,
    CommunityComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    BaseModule,
    HttpClientModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    DownloadService,
    FileLoaderService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
